import React from 'react';

/**
 * TodayBodyCard — Card 1 in the vertical hierarchy.
 * Three quiet stats + one Apple-Intelligence-styled focus line.
 */
export default function TodayBodyCard({ energy, mood, recovery, focus, onDetails }) {
  return (
    <div className="cx-glass" data-testid="card-today-body">
      <div className="cx-card-hd">
        <div className="cx-card-lbl">Today&apos;s Body</div>
        <button className="cx-card-view" onClick={onDetails} data-testid="card-today-body-details">
          Details
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="m9 6 6 6-6 6"/>
          </svg>
        </button>
      </div>
      <div className="cx-body-stats">
        <div className="cx-stat">
          <div className="cx-v cx-accent">{energy}</div>
          <div className="cx-k">Energy</div>
        </div>
        <div className="cx-stat">
          <div className="cx-v">{mood}</div>
          <div className="cx-k">Mood</div>
        </div>
        <div className="cx-stat">
          <div className="cx-v">{recovery}<span className="cx-u">%</span></div>
          <div className="cx-k">Recovery</div>
        </div>
      </div>
      <div className="cx-ai-line">
        <b>Today&apos;s focus:</b> {focus}
      </div>
    </div>
  );
}
